import { DiscoverDetailContainer } from 'modules/Discover'
import React from 'react'

type Props = {}

const DiscoverDetail = (props: Props) => {
  return (
    <DiscoverDetailContainer />
  )
}

export default DiscoverDetail